/* eslint-disable @typescript-eslint/naming-convention */
export interface CustomFields {
  Decimal1: number | null;
  Decimal2: number | null;
  Decimal3: number | null;
  Decimal4: number | null;
  Decimal5: number | null;
  String1: string;
  String2: string;
  String3: string;
  String4: string;
  String5: string;
  String6: string;
  String7: string;
  String8: string;
  String9: string;
  String10: string;
  String11: string;
  String12: string;
  String13: string;
  String14: string;
  String15: string;
  String16: string;
  String17: string;
  String18: string;
  String19: string;
  String20: string;
  String21: string;
  String22: string;
  String23: string;
  String24: string;
  String25: string;
  String26: string;
  String27: string;
  String28: string;
  String29: string;
  String30: string;
  DateTime1: Date | null;
  DateTime2: Date | null;
  DateTime3: Date | null;
  DateTime4: Date | null;
  DateTime5: Date | null;
  Bool1: boolean | null;
  Bool2: boolean | null;
  Bool3: boolean | null;
  Bool4: boolean | null;
  Bool5: boolean | null;
}
